/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?268fbe72917c24b163e6712f';

u.use(UIBootstrap5);

export default u;

$(() => {
  $('.j-list-scroll').on('click', function (e) {
    e.preventDefault();

    const anchor = $(this).attr('href');
    const linkScroll = $(anchor).offset().top;

    $('html,body').stop().animate({
      scrollTop: linkScroll - 150
    }, 100);
  });
});
